// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vat: CountryValidator<"RO"> = createValidator(
  "ro.vat",
  151,
);

export default vat;
export const compact = vat.compact;
export const format = vat.format;
export const validate = vat.validate;
export const generate = (): string =>
  vat.generate?.() ??
  (() => {
    throw new Error(
      "Validator ro.vat cannot generate values",
    );
  })();
